// api
import { fetchApi } from '@/api'
// actions
const adminTurnsAll = (context) => {
  let url = 'admin/turns'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_TURNS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminTurnsForm = (context) => {
  let url = 'admin/turns/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_TURNS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminTurnsShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'admin/turns/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_TURNS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const adminTurnsCreate = (context, payload) => {
  let url = 'admin/turns'
  console.log(payload)
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('ADMIN_TURNS_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminTurnsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/turns/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ADMIN_TURNS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminTurnsDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/turns/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('ADMIN_TURNS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  adminTurnsAll,
  adminTurnsForm,
  adminTurnsShow,
  adminTurnsCreate,
  adminTurnsUpdate,
  adminTurnsDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/turns/actions.js